export default __webpack_public_path__ + "static/media/Ghiottona.1e909946.jpg";